import React from "react";
import ActivityCheckinShopVisit from "./Layout/ShopVisit";
import { useSearchParams } from "react-router-dom";

const ActivityCheckin: React.FC = (): JSX.Element => {
  const [query] = useSearchParams();
  let type: string | null = query.get("type");

  enum activityType {
    shopVisit = "shop-visit",
    farmerMeeting = "farmer-meeting",
    demoPlot = "demo-plot",
  }

  return (
    <div className="px-5">
      {type === activityType.shopVisit && <ActivityCheckinShopVisit />}
    </div>
  );
};

export default ActivityCheckin;
